import { legacyApiAuth, wiggotAPI } from '@wiggot/apis'
import type {
  IResponseGetAddOns,
  IResponseGetPlans,
  IResponseGetShopData,
  IResponseService
} from '../../interfaces/src'

export const getPlans = async (): Promise<
  IResponseService<IResponseGetPlans>
> => {
  try {
    const response = await legacyApiAuth.get<any>('/v2.0.2/payments/plans', {
      params: {
        group: 'temporaly_plans'
      }
    })
    if (response) {
      return {
        isSuccess: true,
        data: response
      }
    }
    return {
      isSuccess: false,
      error: 'not found data resources'
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export const getAddOns = async (): Promise<
  IResponseService<IResponseGetAddOns>
> => {
  try {
    const response = await legacyApiAuth.get<any>('/v2.0.2/payments/plans', {
      params: {
        group: 'single_portal_plans'
      }
    })
    if (response) {
      return {
        isSuccess: true,
        data: response
      }
    }
    return {
      isSuccess: false,
      error: 'not found data resources'
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export const getPlansAuthBasic = async (): Promise<
  IResponseService<IResponseGetPlans>
> => {
  try {
    const response = await legacyApiAuth.get<any>(
      '/v2.0.2/admin/prime/landing_packages/info'
    )
    if (response) {
      return {
        isSuccess: true,
        data: response
      }
    }
    return {
      isSuccess: false,
      error: 'not found data resources'
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export const getAddonsAuthBasic = async (): Promise<
  IResponseService<IResponseGetAddOns>
> => {
  try {
    const response = await legacyApiAuth.get<any>(
      '/v2.0.2/admin/prime/landing_packages/info_addons'
    )
    if (response) {
      return {
        isSuccess: true,
        data: response
      }
    }
    return {
      isSuccess: false,
      error: 'not found data resources'
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export const getShopInfoAuthBasic = async (): Promise<
  IResponseService<{ data: IResponseGetShopData; statusCode: string }>
> => {
  try {
    const response = await wiggotAPI.get<any>('/store/products')
    if (response) {
      return {
        isSuccess: true,
        data: response
      }
    }
    return {
      isSuccess: false,
      error: 'not found data resources'
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}
